


import React from 'react';

const BaraemQuestionHeading = ({ activeStep, translationMap, setQuestionStep }) => {
  const steps = [
  { key: 'general', label: translationMap?.general ?? "General" },
  { key: 'grossMotor', label: translationMap?.grossMotor ?? "Gross Motor" },
  { key: 'fineMotor', label: translationMap?.fineMotor ?? "Fine Motor" },
  { key: 'speechAndLanguage', label: translationMap?.speechAndlanguageText ?? "Speech and Language" },
  { key: 'socialEmotional', label: translationMap?.socialEmotional ?? "Social and Emotional" },
  { key: 'problemSolving', label: translationMap?.problemSolvingText ?? "Problem Solving and Self-Help" }];


  return (
    <div className="Step_ul_main_box">
            <ul className="Step_Info_ul_box">
                {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < activeStep;
          const isActive = stepNumber === activeStep;

          return (
            <li key={step.key}>
                            <div
                className={`Step_inner_box ${isCompleted ?
                'completed_box' :
                isActive ?
                'active_box edit_box_border' :
                ''}`
                }>
                
                                <div
                  className={`inner_counter_wrap ${isCompleted ? 'inner_counter_wrap_filled' : ''}`}>
                  
                                    <span className="count_box">
                                        {isCompleted ?
                    <i className="material-symbols-outlined">check</i> :

                    stepNumber
                    }
                                    </span>
                                    <p>{step.label}</p>
                                </div>
                                {isCompleted &&
                <div className="inner_counter_wrap inner_counter_wrap2">
                                        <div className="count_box">
                                            {stepNumber}
                                            <span className="green_circle">
                                                <i className="material-symbols-outlined">check</i>
                                            </span>
                                        </div>
                                        <p
                    onClick={() => setQuestionStep(stepNumber)}
                    style={{ cursor: "pointer", textDecoration: "underline", color: "#007bff" }}>
                    
                                            {translationMap?.edit ?? "Edit"}
                                        </p>
                                    </div>
                }
                            </div>
                        </li>);

        })}
            </ul>
        </div>);

};

export default BaraemQuestionHeading;